import { render, staticRenderFns } from "./PlayerAvatarCropModal.vue?vue&type=template&id=8f60e1a6&scoped=true&"
import script from "./PlayerAvatarCropModal.vue?vue&type=script&lang=js&"
export * from "./PlayerAvatarCropModal.vue?vue&type=script&lang=js&"
import style0 from "./PlayerAvatarCropModal.vue?vue&type=style&index=0&id=8f60e1a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f60e1a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VContainer,VIcon,VRow,VSpacer,VToolbar,VToolbarItems})
